import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    marginTop: 10,
  },
});

export default function LoadingIndicator({ text = 'Chargement...' }) {
  return (
    <View style={styles.container}>
      <ActivityIndicator animating size="large" />
      <Text style={styles.text}>{text}</Text>
    </View>
  );
}
